const addToLs = ({ key, value }) => {
  localStorage.setItem(key, JSON.stringify(value));
};

const removeFromLs = ({ key }) => {
  localStorage.removeItem(key);
};

const getFromLs = ({ key }) => {
  const value = localStorage.getItem(key);
  return value;
};

export default { addToLs, removeFromLs, getFromLs };
